import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";

/**
 * Fields type definition for content type 'TypeTestimonial'
 * @name TypeTestimonialFields
 * @type {TypeTestimonialFields}
 * @memberof TypeTestimonial
 */
export interface TypeTestimonialFields {
    /**
     * Field type definition for field 'headerLabel' (Header Label)
     * @name Header Label
     * @localized false
     */
    headerLabel?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'name' (Name)
     * @name Name
     * @localized true
     */
    name: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'quote' (Quote)
     * @name Quote
     * @localized true
     */
    quote?: EntryFieldTypes.Text;
    /**
     * Field type definition for field 'Description' (Description)
     * @name Description
     * @localized true
     */
    Description?: EntryFieldTypes.Text;
    /**
     * Field type definition for field 'textCta' (textCTA)
     * @name textCTA
     * @localized true
     */
    textCta?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'linkCta' (linkCTA)
     * @name linkCTA
     * @localized false
     */
    linkCta?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'avatar' (Avatar)
     * @name Avatar
     * @localized false
     */
    avatar: EntryFieldTypes.AssetLink;
}

/**
 * Entry skeleton type definition for content type 'testimonial' (Testimonial)
 * @name TypeTestimonialSkeleton
 * @type {TypeTestimonialSkeleton}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-23T19:26:40.900Z
 * @version 19
 */
export type TypeTestimonialSkeleton = EntrySkeletonType<TypeTestimonialFields, "testimonial">;
/**
 * Entry type definition for content type 'testimonial' (Testimonial)
 * @name TypeTestimonial
 * @type {TypeTestimonial}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-23T19:26:40.900Z
 * @version 19
 */
export type TypeTestimonial<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeTestimonialSkeleton, Modifiers, Locales>;

export function isTypeTestimonial<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeTestimonial<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'testimonial'
}
